import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';

// const baseUserURL = `${baseURL}/grt-user-service`;
const mallOpenServiceURL = `${baseURL}/grt-trade-service/open`,
    mallUserServiceURL = `${baseURL}/grt-trade-service/user`;
let url = {
    pList: '/tdProduct/v1/page/search',
    // pDetail: '/tdProduct/v1/',
    pDetail: '/tdProduct/v1/getByBizId/',
    create: '/tdOrder/V1/create',
    cancel: '/tdOrder/V1/cancel/',
    oList: '/tdOrder/V1/page/search',
    oDetail: '/tdOrder/V1/',
    orderPay: '/tdOrder/V1/pay',
    orderStatus: '/tdOrderV1/getPayState',
    orderDelete: '/tdOrder/V1/',
    getConfig: `${baseURL}/grt-trade-service/tdTradeConfig/v1/getByTenantId`
};
//获取通用支付配置
export const getPayConfig = () => {
    return hMacAjax.get(url.getConfig);
};
//商品列表
export const getProductList = (data) => {
    return hMacAjax.post(mallOpenServiceURL + url.pList, data);
};
//获取商品详情通过商品id
export const getProductDetail = (productId) => {
    return hMacAjax.get(mallOpenServiceURL + url.pDetail + productId);
};
//获取商品详情 通过业务id
export const getProductDetailByBusinessId = (business_id) => {
    return hMacAjax.get(mallOpenServiceURL + url.pDetail + business_id);
};
//创建订单
export const createOrder = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.create, data);
};
//删除订单
export const deleteOrder = (id) => {
    return hMacAjax.delete(mallUserServiceURL + url.orderDelete + id);
};
//取消订单
export const cancelOrder = (id, data) => {
    return hMacAjax.get(mallUserServiceURL + url.cancel + id, data);
};
//订单支付
export const orderPay = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.orderPay, data);
};
//订单列表
export const getOrderList = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.oList, data);
};
//订单详情
export const getOrderDetail = (id) => {
    return hMacAjax.get(mallUserServiceURL + url.oDetail + id);
};
export const getOrderStatus = (id) => {
    return hMacAjax.get(mallUserServiceURL + url.orderStatus + '/' + id);
};
